import React, { useState, useEffect } from 'react'
import QuizApi from '../api/QuizApi'
import texts from '../texts'

const FILES = [
  { name: 'vocabulario.json', label: 'Vocabulario general' },
  { name: 'vocabulario_unidad.json', label: 'Vocabulario por unidad' }
]

const Search = () => {
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [allData, setAllData] = useState([])
  const [reviewingWord, setReviewingWord] = useState(null)
  const [reviewMessage, setReviewMessage] = useState('')

  // Cargar ambos ficheros al montar el componente
  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true)
      let merged = []
      for (const file of FILES) {
        try {
          const res = await fetch(`/data/${file.name}`)
          const json = await res.json()
          Object.entries(json).forEach(([category, words]) => {
            // Si todos los valores son objetos, es anidado (subgrupos)
            if (
              typeof words === 'object' &&
              Object.values(words).every((val) => typeof val === 'object')
            ) {
              Object.entries(words).forEach(([subcat, subObj]) => {
                Object.entries(subObj).forEach(([value, jp]) => {
                  let castellano = ''
                  let hiragana = ''
                  let kanji = ''
                  if (typeof value === 'string') {
                    castellano = value
                    hiragana = jp
                  } else if (typeof value === 'object') {
                    castellano = value.castellano || value.romaji || ''
                    hiragana = value.hiragana || jp
                    kanji = value.kanji || ''
                  }
                  merged.push({
                    castellano,
                    hiragana,
                    kanji,
                    category,
                    subcat,
                    file: file.label
                  })
                })
              })
            } else {
              // Categoría plana
              Object.entries(words).forEach(([value, jp]) => {
                let castellano = ''
                let hiragana = ''
                let kanji = ''
                if (typeof value === 'string') {
                  castellano = value
                  hiragana = jp
                } else if (typeof value === 'object') {
                  castellano = value.castellano || value.romaji || ''
                  hiragana = value.hiragana || jp
                  kanji = value.kanji || ''
                }
                merged.push({
                  castellano,
                  hiragana,
                  kanji,
                  category,
                  subcat: category, // para que siempre haya subcat
                  file: file.label
                })
              })
            }
          })
        } catch (e) {
          // Si el archivo no existe, lo ignora
        }
      }
      setAllData(merged)
      setLoading(false)
    }
    fetchAll()
  }, [])

  const handleReviewWord = async (item) => {
    const word = item.hiragana || item.castellano
    const reviewKey = `${item.castellano}-${item.hiragana}`
    setReviewingWord(reviewKey)
    setReviewMessage('')

    try {
      await QuizApi.markWordForReview({
        palabra_castellano: item.castellano,
        hiragana: item.hiragana,
        kanji: item.kanji || null,
        romaji: item.romaji || '',
        source: 'search',
        category: item.category,
        notes: `${item.castellano} (${item.hiragana})`,
        user_id: null
      })
      setReviewMessage(`Se marcó “${word}” para repasar con S.`)
    } catch (error) {
      setReviewMessage(`No se pudo marcar “${word}” para repasar.`)
    } finally {
      setReviewingWord(null)
    }
  }

  // Filtrar resultados en tiempo real
  useEffect(() => {
    if (!query) {
      setResults([])
      return
    }
    const q = query.toLowerCase()
    setResults(
      allData.filter(
        (item) =>
          item.castellano.toLowerCase().includes(q) ||
          item.hiragana.toLowerCase().includes(q) ||
          (item.kanji && item.kanji.toLowerCase().includes(q)) ||
          item.category.toLowerCase().includes(q) ||
          (item.subcat && item.subcat.toLowerCase().includes(q)) // <-- Añadido
      )
    )
  }, [query, allData])

  return (
    <div style={{ maxWidth: 700, margin: 'auto', padding: 24 }}>
      <h2>{texts.search.title}</h2>
      <input
        type='text'
        placeholder={texts.search.placeholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{
          width: '100%',
          padding: 10,
          fontSize: '1.1em',
          marginBottom: 20,
          borderRadius: 6,
          border: '1px solid #bbb',
          boxSizing: 'border-box'
        }}
      />
      {loading && <p>Cargando vocabulario...</p>}
      {!loading && results.length > 0 && (
        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table
            style={{ minWidth: 600, width: '100%', borderCollapse: 'collapse', marginTop: 10 }}
          >
            <thead>
              <tr>
                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Castellano</th>
                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>
                  Hiragana/Katakana
                </th>
                {/* <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Kanji</th> */}
                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Apartado</th>
                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Archivo</th>
                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {results.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.castellano}</td>
                  <td>{item.hiragana}</td>
                  {/* <td>{item.kanji || '-'}</td> */}
                  <td>
                    {item.subcat !== null && item.subcat !== item.category
                      ? item.subcat
                      : item.category}
                  </td>
                  <td>{item.file}</td>
                  <td>
                    <button
                      onClick={() => handleReviewWord(item)}
                      disabled={reviewingWord === `${item.castellano}-${item.hiragana}`}
                      style={{
                        padding: '6px 10px',
                        borderRadius: 6,
                        border: '1px solid #1d4ed8',
                        background: '#eff6ff',
                        color: '#1d4ed8',
                        cursor: 'pointer'
                      }}
                    >
                      {reviewingWord === `${item.castellano}-${item.hiragana}`
                        ? 'Enviando...'
                        : 'Marcar S'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {!loading && query && results.length === 0 && <p>No se encontraron resultados.</p>}
      {reviewMessage && (
        <p style={{ marginTop: 14, color: '#0a7d2e', fontWeight: 600 }}>{reviewMessage}</p>
      )}
    </div>
  )
}

export default Search
